import React from 'react';

const STATS = [
  { key: 'mc', label: 'Main Categories', color: 'from-blue-500 to-blue-700' },
  { key: 'c', label: 'Categories', color: 'from-indigo-500 to-indigo-700' },
  { key: 'sc', label: 'Sub-Categories', color: 'from-purple-500 to-purple-700' },
  { key: 'p', label: 'Products', color: 'from-orange-500 to-[#ee5e23]' },
  { key: 's', label: 'Vendors', color: 'from-emerald-500 to-emerald-700' },
  { key: 'cust', label: 'Customers', color: 'from-cyan-500 to-cyan-700' },
  { key: 'e', label: 'Enquiries', color: 'from-rose-500 to-rose-700' },
  { key: 'r', label: 'Requirements', color: 'from-amber-500 to-amber-700' },
];

const AdminOverview = ({ overview }) => (
  <div>
    <h1 className="text-2xl font-bold text-gray-900 mb-1">Dashboard</h1>
    <p className="text-sm text-gray-600 mb-6">Welcome back. Here&apos;s your marketplace at a glance.</p>
    {overview ? (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {STATS.map((s) => (
          <div key={s.label} className={`bg-gradient-to-br ${s.color} text-white rounded-lg p-5 shadow`}>
            <div className="text-3xl font-bold">{overview[s.key].length}</div>
            <div className="text-sm opacity-90 mt-1">{s.label}</div>
          </div>
        ))}
      </div>
    ) : (
      <div className="text-gray-500">Loading...</div>
    )}

    {overview && (
      <div className="grid md:grid-cols-2 gap-4 mt-8">
        <div className="bg-white border border-gray-200 rounded-lg p-4">
          <h3 className="font-semibold mb-3">Recent Enquiries</h3>
          {overview.e.length === 0 ? (
            <div className="text-sm text-gray-500">No enquiries yet.</div>
          ) : (
            <ul className="space-y-2">
              {overview.e.slice(0, 5).map((en) => (
                <li key={en.id} className="text-sm border-b pb-2 last:border-0">
                  <div className="font-medium">{en.name} <span className="text-gray-500">• {en.mobile}</span></div>
                  <div className="text-xs text-gray-600 truncate">{en.product_name || en.message}</div>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="bg-white border border-gray-200 rounded-lg p-4">
          <h3 className="font-semibold mb-3">Recent Requirements</h3>
          {overview.r.length === 0 ? (
            <div className="text-sm text-gray-500">No requirements yet.</div>
          ) : (
            <ul className="space-y-2">
              {overview.r.slice(0, 5).map((rq) => (
                <li key={rq.id} className="text-sm border-b pb-2 last:border-0">
                  <div className="font-medium">{rq.product} <span className="text-gray-500">• {rq.quantity} {rq.unit}</span></div>
                  <div className="text-xs text-gray-600">{rq.name} • {rq.mobile} • {rq.city}</div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    )}
  </div>
);

export default AdminOverview;
